import { render, staticRenderFns } from "./CartMain.vue?vue&type=template&id=0bd1dd19&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./CartMain.vue?vue&type=script&lang=js"
export * from "./CartMain.vue?vue&type=script&lang=js"
import style0 from "./CartMain.vue?vue&type=style&index=0&id=0bd1dd19&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1dd19",
  null
  
)

export default component.exports